<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  @let store = offshoreOperationalStore;

  <div class="flex flex-col gap-2">
    <nsp-select-input
      id="eventSelection"
      name="eventType"
      label="Event"
      [required]="true"
      [labelWidthPercentage]="33"
      [options]="eventOptions"
      [showClear]="true"
      [value]="store.reportOptions().eventType.value"
      [ngModel]="store.reportOptions().eventType.value"
      placeholder="Select an event"
    />
    <nsp-select-input
      id="operationSelection"
      name="operationType"
      label="Operation Selection"
      [readonly]="!store.reportOptions().eventType.value"
      [required]="true"
      [labelWidthPercentage]="33"
      [options]="filteredOperationOptions()"
      [showClear]="true"
      [value]="store.reportOptions().operationType.value"
      [ngModel]="store.reportOptions().operationType.value"
      placeholder="Select an operation"
    />
  </div>
</form>
